import { Dispatch, SetStateAction, useState } from "react";
import { Modal as ReactModal } from "react-responsive-modal";
// import MemoQRCode from "@assets/SVG/QRCode";
import Link from "next/link";
import { ModalHeader } from "@app/sign-in/SignInConfirmationModal";
import MemoFullBlockbeatLogo from "@assets/SVG/Logo/FullBlockbeatLogo";
import SupplyOTP from "@app/auth/SupplyOTP";
import EmailInput from "@app/auth/EmailInput";
import PasswordInput from "@app/auth/PasswordInput";
import SocialLogins from "@app/auth/SocialLogins";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { isEmpty } from "lodash";

export const AuthenticationModal = ({
    show,
    setShow,
    setUserHasAPassword,
}: {
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    setUserHasAPassword: Dispatch<SetStateAction<boolean>>;
}) => {
    const [email, setEmail] = useState("");
    const [showPasswordInput, setShowPasswordInput] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorType, setErrorType] = useState("");
    const [showOTPInput, setShowOTPInput] = useState(false);
    const [methodId, setMethodId] = useState("");
    const [showConfirmPassword, setShowConfirmPassword] = useState(true);

    const onCloseModal = () => setShow(false);

    return (
        <ReactModal
            open={show}
            onClose={onCloseModal}
            focusTrapped={false}
            center
            showCloseIcon={false}
            closeOnEsc={false}
            closeOnOverlayClick={false}
            classNames={{
                modal: "modal-bg-none min-w-100 modal-radius-5 modal-padding-0 modal-margin-0",
            }}
        >
            <div className="pb-6.75 flex flex-col items-center gap-[33px] bg-[#15191E] px-36 pt-[38px]">
                <MemoFullBlockbeatLogo className="h-12 w-56" />
                <p className="text-lg font-normal leading-6 text-white">Welcome to BlockBeat Beta!</p>
                <div className="w-100 relative mb-20 mt-8 flex items-start rounded-lg bg-base-100 p-0">
                    <div className="flex min-h-[305px] w-full flex-col items-center justify-center gap-6 rounded-lg px-4 py-6">
                        {(success || !isEmpty(errorType)) && (
                            <div className="flex w-full flex-col items-center gap-1 px-4 pb-5 pt-4">
                                <ModalHeader success={success} errorType={errorType} />
                            </div>
                        )}
                        {!showOTPInput && (
                            <>
                                {showPasswordInput && (
                                    <div className="flex w-full items-center justify-start">
                                        <div
                                            className="flex cursor-pointer gap-2 hover:brightness-75"
                                            onClick={() => setShowPasswordInput(false)}
                                        >
                                            <ArrowLeftIcon className="size-4" />
                                            <p className="text-[14px] font-light leading-4 text-neutral">
                                                Back to Email
                                            </p>
                                        </div>
                                    </div>
                                )}

                                <p className="text-[14px] font-light leading-4 text-neutral">
                                    {!showPasswordInput
                                        ? "Login or Sign Up"
                                        : showConfirmPassword
                                          ? "Please Create a Password"
                                          : "Please Enter Your Password"}
                                </p>
                            </>
                        )}

                        {showOTPInput ? (
                            <SupplyOTP
                                email={email}
                                methodId={methodId}
                                setMethodId={setMethodId}
                                setShowPasswordInput={setShowPasswordInput}
                                setShowOTPInput={setShowOTPInput}
                            />
                        ) : (
                            <div className="flex w-full flex-col items-start gap-3">
                                {!showPasswordInput ? (
                                    <EmailInput
                                        email={email}
                                        setEmail={setEmail}
                                        setShowPasswordInput={setShowPasswordInput}
                                        setMethodId={setMethodId}
                                        setShowOTPInput={setShowOTPInput}
                                        setSuccess={setSuccess}
                                        setErrorType={setErrorType}
                                        setShowConfirmPassword={setShowConfirmPassword}
                                    />
                                ) : (
                                    <PasswordInput
                                        email={email}
                                        setErrorType={setErrorType}
                                        setSuccess={setSuccess}
                                        setUserHasAPassword={setUserHasAPassword}
                                        showConfirmPassword={showConfirmPassword}
                                    />
                                )}

                                {/* socials */}
                                {!showPasswordInput && <SocialLogins />}

                                <div className="flex flex-col items-center gap-1 p-0">
                                    <Link
                                        href={`/reset-password?email=${email}`}
                                        className="cursor-pointer hover:brightness-75"
                                        passHref
                                    >
                                        <div className="flex items-start gap-2 p-0">
                                            <p className="text-center text-xs text-primary">
                                                Forgot password?
                                            </p>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <p className="mt-4 text-center text-[10px] font-light leading-3 text-light-blue">
                    By proceeding you agree to <span className="text-white-blue">the</span>
                    <a
                        href="https://www.blockbeat.io/terms-and-conditions"
                        target="_blank"
                        className="text-powder-blue"
                    >
                        {" "}
                        Terms and Conditions
                    </a>
                    <span className="text-white-blue">.</span>
                </p>
            </div>
        </ReactModal>
    );
};
